// extracted by mini-css-extract-plugin
module.exports = {"footer__links":"FooterLinks_footer__links__3xsZQ"};